import React, { useState, useEffect } from 'react'
import { Link, Grid, Typography } from '~components'
import { SentryCaptureException } from '~utils'
import {
  CenteredPage,
  CenteredPageContainer,
  ForgotPasswordForm,
} from '~components/pages'
import { useRouter } from 'next/router'
import { useMst } from '~stores'
import { Notify } from 'notiflix'
import { Transition } from '@headlessui/react'

interface PasswordForgotPageProps {}

const PasswordForgotPage: React.FC<PasswordForgotPageProps> = () => {
  const router = useRouter()
  const { userStore } = useMst()
  const [error, setError] = useState<{ message: string }>()
  const [loading, setLoading] = useState(false)

  const [show, setShow] = useState(false)

  useEffect(() => {
    setShow(!show)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.asPath])

  const onSubmit = async ({ email }) => {
    setLoading(true)
    try {
      await userStore.authResetPasswordRequest(email)
      router.push('/password/forgot-sent')
    } catch (e) {
      if (e.response.status === 404) {
        router.push('/password/forgot-sent')
      } else {
        Notify.failure('An error occurred, try again later.')
        setError({ message: 'An error occurred, try again later.' })
        SentryCaptureException(e)
      }
    }
  }

  return (
    <div className="pt-32 md:pt-36 pb-32 md:bg-light-blue min-h-screen">
      <Transition
        show={show}
        enter="transition ease-out duration-500"
        enterFrom="opacity-0 translate-y-10"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-out duration-500"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-10"
      >
        <Grid className="md:min-h-[76vh]">
          <div className="col-span-4 md:col-span-8 md:col-start-3 flex justify-center">
            <div className="md:bg-white md:rounded-[60px] md:px-10 lg:px-32 md:py-[90px] w-full 2xl:max-w-[64rem] flex justify-start flex-col md:h-full">
              <h1 className={'text-blue h2 mb-10 md:mb-8'}>Reset Password</h1>
              <div className={'copy-2 mb-8'}>
                Please verify your email and we'll send instructions to reset
                your password.
              </div>

              <ForgotPasswordForm
                error={error}
                loading={loading}
                onSubmit={onSubmit}
                type={'reset'}
              />
            </div>
          </div>
        </Grid>
      </Transition>
    </div>
  )
}

export default PasswordForgotPage
